import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import LoadingSpinner from './LoadingSpinner';
import NavigationHeader from './NavigationHeader';

const PrivateRoute = ({ children }) => {
    const { isAuthenticated, isLoading } = useAuth();
    
    // Get identifier from localStorage OR sessionStorage
    const uuid = localStorage.getItem('UUID') || sessionStorage.getItem('dentistUuid');

    if (isLoading) return <LoadingSpinner />;

    if (!isAuthenticated) {
        // Ensure UUID is stored in both places for reliability
        if (uuid) {
            localStorage.setItem('UUID', uuid);
            sessionStorage.setItem('dentistUuid', uuid);
            return <Navigate to={`/${uuid}`} replace />;
        }
        
        // No UUID found - redirect to home instead of error page
        console.warn('No UUID found in PrivateRoute - redirecting to home');
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <NavigationHeader />
            {children}
        </>
    );
};

export default PrivateRoute;